import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.778 3.99995C20.9734 3.99995 22.0281 5.05463 22.0281 6.24995V7.6562C27.161 8.64058 31.028 13.2109 31.028 18.625V20.4531C31.028 23.6171 32.0828 26.711 34.0515 29.242L35.1063 30.5078C35.528 31.0703 35.5983 31.7733 35.317 32.3358C35.0358 32.8983 34.4733 33.25 33.8405 33.25H5.7156C5.0125 33.25 4.45 32.8983 4.1687 32.3358C3.8875 31.7733 3.9578 31.0703 4.3796 30.5078L5.4343 29.242C7.4031 26.711 8.5281 23.6171 8.5281 20.4531V18.625C8.5281 13.2109 12.3953 8.64058 17.5281 7.6562V6.24995C17.5281 5.05463 18.5125 3.99995 19.778 3.99995ZM19.778 10.75C15.4187 10.75 11.9031 14.3359 11.9031 18.625V20.4531C11.9031 23.8281 10.9187 27.0625 9.0906 29.875H30.3953C28.567 27.0625 27.653 23.8281 27.653 20.4531V18.625C27.653 14.3359 24.0671 10.75 19.778 10.75ZM24.278 35.5C24.278 36.6953 23.7859 37.8905 22.9421 38.7343C22.0984 39.578 20.9734 40 19.778 40C18.5828 40 17.3875 39.578 16.5437 38.7343C15.7 37.8905 15.278 36.6953 15.278 35.5H19.778H24.278Z",
		fill: "#111111"
	})
});
export default SvgBell;
